// extracted by mini-css-extract-plugin
export default {"empty":"EmptyMarketingMaterials_empty__SSzpd","text":"EmptyMarketingMaterials_text__V9kV+","icon":"EmptyMarketingMaterials_icon__nQMZp"};